import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, Filter, User, Users } from 'lucide-react';

interface DrawerControlsProps {
  searchQuery: string;
  showAllUsers: boolean;
  displayListLength: number;
  selectedUsersCount: number;
  onSearchChange: (value: string) => void;
  onShowAllUsersChange: (showAll: boolean) => void;
}

export const DrawerControls: React.FC<DrawerControlsProps> = ({
  searchQuery,
  showAllUsers,
  displayListLength,
  selectedUsersCount,
  onSearchChange,
  onShowAllUsersChange,
}) => {
  return (
    <div className="p-3 border-b border-border shrink-0 space-y-3">
      {/* Søkefelt */}
      <div className="relative">
        <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Søk på navn eller telefon..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-8 bg-slate-50/50 focus:bg-white text-sm"
        />
      </div>

      <div className="flex items-center gap-2">
        <Filter className="h-4 w-4 text-muted-foreground" />
        <p className="text-sm font-medium">
          {showAllUsers ? 'Alle medarbeidere' : 'Med talent'} ({displayListLength})
          {selectedUsersCount > 0 && ` • ${selectedUsersCount} valgt`}
        </p>
      </div>
      
      <div className="flex gap-2">
        <Button
          variant={!showAllUsers ? 'default' : 'outline'}
          size="sm"
          onClick={() => onShowAllUsersChange(false)}
          className="flex-1 gap-1.5"
        >
          <Users className="h-4 w-4" />
          <span className="hidden sm:inline">Med talent</span>
        </Button>
        <Button
          variant={showAllUsers ? 'default' : 'outline'}
          size="sm"
          onClick={() => onShowAllUsersChange(true)}
          className="flex-1 gap-1.5"
        >
          <User className="h-4 w-4" />
          <span className="hidden sm:inline">Alle</span>
        </Button>
      </div>
    </div>
  );
};

